import React from "react";
// import classes from "modules/legal/atoms/Title.module.css";
import styled from "styled-components";

const Heading1 = styled.h1`
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 20px;
  font-feature-settings: "cpsp" on;
  color: #4f4f4f;
`;

export const Title: React.FC = ({ children }) => {
  return <Heading1>{children}</Heading1>;
};
